import { QueovalBase, QueovalDik, QueovalDate} from '../global/class.global';
import { Select } from '../utilities/utilities.model';
import { QueovalDateService } from '../../services/queovalDate.service';
import { CommentFact } from './gestionfactures.model';


export class ReglementModel extends QueovalBase {
  public Reglement: Reglement;
  public ListModeReglements: Array<QueovalDik>;
  public ListEcritureBq: Array<QueovalDik>;
  public ListEntites: Array<EntiteReglement>;
 // public StrSymboleMonnaie: string;
  public SelectedCommentFact: CommentFact;
  public EcartPerteProfit: number;
  public StrFilterForRelance: string;
  public ListRelanceFactures: Array<RelanceFacture>;
  public StrSelectedEntite: string;
  public filtreSEPA: FiltreSEPA;
  public ListPrelevementsSEPA: Array<PrelevementSEPA>;
  public ListFichiersSEPA: Array<FichierSEPA>;
  public ListNumeroPrelevementSepa: Array<NumeroSEPA>;
  public forceBrouillard: boolean;
  public StrSelectedClient: string;
  public IsTokenIbizaExist: boolean;
  public IsTokenMyDsoExist: boolean;
  public strIbizaResponse: qIbizaResponse;
  public IbizaRequest: IbizaRequest;
  public pieceColumnDefs: Array<Map<string, any>>;
  public pieceRowData: Array<Map<string, any>>;
  public clientColumnDefs: Array<Map<string, any>>;
  public clientRowData: Array<Map<string, any>>;
  public contactColumnDefs: Array<Map<string, any>>;
  public contactRowData: Array<Map<string, any>>;
  public CallAPI: boolean;

  public Ok: boolean;
  constructor() {
    super();
    this.filtreSEPA = new FiltreSEPA();
    this.ListPrelevementsSEPA = new Array<PrelevementSEPA>();
    this.ListFichiersSEPA = new Array<FichierSEPA>();
    this.ListNumeroPrelevementSepa = new Array<NumeroSEPA>();
    this.forceBrouillard = false;
  }

}
export class EntiteReglement {
  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
    this.isShown = false;
    this.loadedDatas = false;
    this.isLoading = false;
    this.isExporting = false;
  }
  public key: string;
  public value: string;
  public IsFull: boolean;
  public IsDso: boolean;

  public pieceColumnDefs: any;
  public pieceRowData: any[];

  public clientColumnDefs: any;
  public clientRowData: any[];

  public contactColumnDefs: any;
  public contactRowData: any[];

  public isShown: boolean;
  public loadedDatas: boolean;
  public isLoading: boolean;
  public isExporting: boolean;
}
export class qIbizaResponse {
  public columnDefs: string;
  public rowData: string;
}

export class IbizaRequest {
  public dtDebut: QueovalDate;
  public dtFin: QueovalDate;
  public lettrage: string;
  public cols: any;
  public Entites: Array<{ value: string, index: number }>;
}

export class Reglement {
  public StrIdent: string;
  public Montant: number;
  public Date: QueovalDate;
  public DatePrelevement: QueovalDate;
  public Libelle: string;
  public ModeReglement: string;
  public StrNumFolio: string;
  public EcritureBanque: string;
  public TypeEcart: string;
  public ListLigneReglements: Array<LigneReglement>;
  public MontantPep: number;
  public StrIdFinanceur: string;
  public SoldeARegler: number;
  public RePrelever: boolean;
  public toDelete: boolean;
  constructor() {
    this.TypeEcart = '0';
  }
}

export class LigneReglement {
  public StrIdFinanceur: string;
  public StrIdFacture: string;
  public StrNumFacture: string;
  public SoldeARegler: number;
  public MontantReglement: number;
  public IsEqual: boolean;
}

export class RelanceFacture {
  public BoolIncreaseNumRelance: boolean;
  public StrIdent: string;
  public NumRelance: number;
  public StrIdClient: string;
  public DatePeriode: string;
  public DateRelance: string;
  public TitreFacture: string;
  public IdEntite: string;

  // #region DOCX
  public DocxInfo: DocumentInfo;
  public DocxPostMode: string;
  public DocxParams: string;
  public DocxDataFilter: any;
  // #endregion
}

// #region DOCX
export class DocumentInfo {
  public IdBO: string;
  public IdDonnee: string;
  public IdRelation: string;
  public ModelFullPath: string;
  public ModelName: string;
  public Details: Array<DocumentDetails>;
}

export class DocumentDetails {
  public IdBO: string;
  public IdDonnee: string;
  public IdRelation: string;
}

// Model servant uniquement à générer les relances docx (coté client)
export class DocsRelanceModel extends QueovalBase {
  public Info: DocumentInfo;
  public PostMode: string;
  public DocParams: string;
  public DataFilter: any;
  public DocumentsPath: Array<string>;
}


// #endregion

// #region prelevement SEPA
export class PrelevementSEPA {
  IdClient: string;
  IdBanque: string;
  IdEcheance: string;
  IdFacture: string;
  IdAcompte: string;
  IdRIB: string;
  Ident: string;
  LibelREG: string;
  Date_REG: Date | null;
  MontaREG: string;
  NumRef: string;
  RaisoCLI: string;

  constructor() {
    this.IdClient = '';
    this.IdBanque = '';
    this.IdEcheance = '';
    this.IdFacture = '';
    this.IdAcompte = '';
    this.IdRIB = '';
    this.Ident = '';
    this.LibelREG = '';
    this.Date_REG = new Date();
    this.MontaREG = '';
    this.NumRef = '';
    this.RaisoCLI = '';
  }
}

export class FiltreSEPA {
  etat: Select;
  date: QueovalDate;
  dateFin: QueovalDate;
  filtrePrelevement: boolean;
  comptabilisationGlobale: boolean;
  regrouperClient: boolean;
  entite: Select;
  groupe: Select;
  numeroPrelevement: NumeroSEPA;

  constructor() {
    this.etat = new Select('0', '-------');
    this.entite = new Select('0', '-------');
    this.groupe = new Select('0', '-------');
    this.numeroPrelevement = new NumeroSEPA();
    this.date = new QueovalDateService().Now();
    this.filtrePrelevement = false;
    this.comptabilisationGlobale = true;
    this.regrouperClient = false;
  }
}

export class FichierSEPA {
  Ident: string;
  Label: string;
  FilePath: string;
  Date: Date | null;
  Selected: boolean;

  constructor() {
    this.Ident = '';
    this.Label = '';
    this.FilePath = '';
    this.Date = new Date();
    this.Selected = false;
  }
}

export class NumeroSEPA extends Select {
  public date: QueovalDate;
  public numero: string;
  constructor() {
    super();
    this.id = '';
    this.value = '';
    this.date = new QueovalDate();
    this.numero = '';
  }
}

// #endregion
